import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { marquetteConfig } from "./data";

export default function MarquettePage() {
  return <CityPageTemplate config={marquetteConfig} />;
}